import { useState, type FormEvent } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综艺', to: '/category/variety' },
  { label: '关于', to: '/about' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
      isActive ? 'text-primary-600' : 'text-foreground-600 hover:text-primary-600'
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200/70">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer" onClick={() => setMenuOpen(false)}>
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950">
              <i className="ri-film-line text-xl"></i>
            </span>
            <span className="text-xl font-extrabold text-foreground-950 tracking-tight">看片</span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={handleSearch} className="hidden lg:flex items-center gap-2">
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索电影、电视剧、综艺"
                  className="w-56 pl-9 pr-3 py-2 text-sm rounded-md bg-background-100 border border-background-300/70 text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                />
              </div>
              <button
                type="submit"
                className="px-4 py-2 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                搜索
              </button>
            </form>

            <Link
              to="/search"
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </Link>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="菜单"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50 px-4 py-3 animate-fade-in">
          <form onSubmit={handleSearch} className="flex items-center gap-2 mb-3">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视"
                className="w-full pl-9 pr-3 py-2 text-sm rounded-md bg-background-100 border border-background-300/70 text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400"
              />
            </div>
            <button
              type="submit"
              className="px-4 py-2 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>
          <div className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-2 py-3 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                    isActive ? 'text-primary-600 bg-primary-50' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}